'use strict';
window.addToCart = function (CourseType,data, callback, errorCallback, dataLayerOpt) {
	var url = {
		"course": window.lcb.config.apiPaths.AddSessionToShoppingCart,
		"programsessiongroup": window.lcb.config.apiPaths.AddSessionGroupToShoppingCart,
		"programintake": window.lcb.config.apiPaths.AddProgramIntakeToShoppingCart
	};
    $.ajax({
        url:url[CourseType.toLocaleLowerCase()],
        data: data,
        dataType: "text",
        success: function(data) {
        	var  json= $.parseJSON(data);

        	if (typeof(json.STATUS) !== 'undefined' && json.STATUS == 'VALID') {
				updateSchoolbagCount(json.bagCount);
				if(dataLayerOpt !== undefined){
					GAPush({'event':'schoolbag','eventCategory':dataLayerOpt.CourseName,'eventAction':'add to schoolbag','eventLabel':dataLayerOpt.CampusName});
				}
				callback(json);
           	}
           	else {
				if (errorCallback != null) {
					errorCallback(json);
				} else  {
					var errorLabels = window.lcb.constant.addCourseApiErrors;
					if (errorLabels[json.ERROR] != null) {
						GenericErrorHandler({message:$.i18n._(errorLabels[json.ERROR])});
					} else {
						GenericErrorHandler();
					}
				}
           	}
        },
        error: function(e) {
			if (errorCallback != null) {
				errorCallback(e);
			} else  {
				GenericErrorHandler();
			}
        }
    });
}

window.removeFromCart = function (type,id,callback,errorCallback) {
    $.ajax({
        url:window.lcb.config.apiPaths.RemoveFromShoppingCart,
        data: {lineID: id},
        dataType: "text",
        success: function(data) {
        	var  json= $.parseJSON(data);
        	if (typeof(json.STATUS) !== 'undefined' && (json.STATUS == 'EMPTY' || json.STATUS == 'FULL') ) {
				callback(json);
           	}
           	else {
           		errorCallback(data);
           	}
        },
        error: function(e) {
			errorCallback(e);
        }
    });

	return false;
}

window.loadSchoolBag = function (bagData) {
	LoadUnderscoreTemplate(window.lcb.config.templatePaths.schoolbag, bagData, {
		onSuccess: function(html){
			$('.school-bag-container').html(html);

			$('.update-from-schoolbag').change(function() {
				updateQuantityFromBag($(this).data('lineid'),$(this).val());
			});

			$('.remove-from-schoolbag').click(function() {
				removeFromCart($(this).data('type'), $(this).data('lineid'),
				// Succcess event
				function(json)  {
					updateSchoolbagCount((json.bagCount == null)? 0 : json.bagCount);

					if (json.STATUS == 'FULL') {
						// Reload the content after the remove.
						loadSchoolBag(json.bag);
					} else {
						$('.school-bag-container').html('');
						$('.school-bag-empty').removeClass('hide');
						$('.school-bag-term-condition').addClass('hide');
					}
				},
				// Error event
				function(e){
					GenericErrorHandler();
				});
			});
		}
	});
}

window.updateQuantityFromBag = function (lineID, quantity) {
	var url = window.lcb.config.apiPaths.UpdateQuantityFromShoppingCart;
	var errorLabels = window.lcb.constant.updateCourseApiErrors;

	LoadApiData(url, 'lineID=' + lineID + '&quantity=' + quantity, {
				onSuccess: function (data) {
						if (data.STATUS == 'VALID') {
							updateSchoolbagCount((data.bagCount == null)? 0 : data.bagCount);
							loadSchoolBag(data.bag);
						} else {
							// Get first error and display it
							var errorCat = Object.keys(data.ERRORS)[0];
							var errorMsg = errorLabels[errorCat] == null ? null : errorLabels[errorCat][data.ERRORS[errorCat]];
							GenericErrorHandler({message:(errorMsg == null ? 'invalid arguments' : $.i18n._(errorMsg))});
						}
				}
			});
}

window.updateSchoolbagCount = function(count){
	$('#SchoolBagCount').html($.i18n._(13414, ['',count]));
}

